import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ListingService } from 'src/app/_shared/service/listings.service';
import { ClientDashboardState } from 'src/app/client-dashboard/state/client-dashboard.state';
import { PropertyState } from 'src/app/workspace/state/property.state';

@Component({
  selector: 'app-expired-listings',
  templateUrl: './expired-listings.component.html',
  styleUrls: ['./expired-listings.component.scss'],
})
export class ExpiredListingsComponent implements OnInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  expiredListingsDataSource = new MatTableDataSource<any>([]);
  isDataLoading: boolean = true;
  onDestroyNotifier$ = new Subject();
  expiredListingsFilter: FormGroup;
  displayedColumns: string[] = [
    'address',
    'name',
    'listedOn',
    'dom',
    'listedPrice',
    'owner',
    'email',
    'currentPrice',
    'priceReduction',
    'equity',
    'sendMail',
  ];
  click: any;

  constructor(
    private listingService: ListingService,
    public clientDashboardState: ClientDashboardState,
    public formBuilder: FormBuilder,
    public propertyState: PropertyState
  ) { }
  totalRecords = 0;
  pageSize = 5;
  currentPage = 1;

  ngOnInit() {
    this.clientDashboardState.expiredList$.subscribe((data: any) => {
      this.expiredListingsDataSource.data = data?.result || [];
      this.totalRecords = data?.total || 0;
    });

    this.clientDashboardState.expiredListInfo$.subscribe((res: any) => {
      if (res) {
        this.expiredListingsDataSource.data = res?.result || [];
        this.totalRecords = res?.total || 0;
      }
    });

    this.expiredListingsFilter = this.formBuilder.group({
      duration: [90, [Validators.pattern(/^[1-9]\d*$/)]],
    });

    this.getExpiredListings({
      page: this.currentPage,
      pageSize: this.pageSize,
    });

    this.refreshExpiredListingsTable();
  }

  canReset(): boolean {
    const control = this.expiredListingsFilter.get('duration');

    return !!(
      control &&
      control.dirty &&
      control.value !== null &&
      control.value !== '' &&
      control.value !== undefined
    );
  }
  refreshExpiredListingsTable() {
    this.clientDashboardState.refreshTable$.pipe(takeUntil(this.onDestroyNotifier$)).subscribe((res) => {
      if (!res) return;
      const pageIndex = res.pageIndex;
      this.getExpiredListings({
        page: pageIndex,
        pageSize: this.pageSize,
      });
    });
  }

  loadPage(page: number, limit: number) {
    this.isDataLoading = true;
    const params = {
      page: page,
      pageSize: limit,
      days: this.expiredListingsFilter.get('duration')?.value,
    };

    this.getExpiredListings(params);
  }

  actions(row?: any, key?: any) {
    const currentPage = this.paginator.pageIndex + 1;
    if (key == 'expiredListings') {
      this.clientDashboardState.openCreateMailSheetValue = true;
      this.clientDashboardState.mailSheetContextValue = {
        source: 'expired-listings',
        data: row,
      };
    }

    if (key == 'editEmail') {
      this.clientDashboardState.expiredListingsSheetContextValue = {
        source: 'expired-listings',
        data: row,
        currentPage: currentPage,
      };
      this.clientDashboardState.openAddexpireListingsNoteSheetValue = true;
    }
  }
  filterExpiredListings() {
    const control = this.expiredListingsFilter.get('duration');

    if (!control || control.invalid) {
      control?.markAsTouched();
      return;
    }

    const duration = control.value;
    this.getExpiredListings({
      page: 1,
      pageSize: 5,
      days: duration,
    });
    this.paginator.pageIndex = 0;
  }

  resetFilter() {
    this.expiredListingsFilter.reset({
      duration: 90,
    });

    this.getExpiredListings({
      page: 1,
      pageSize: 5,
    });
    this.paginator.pageSize = 5;
    this.paginator.pageIndex = 0;
  }

  onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex + 1;
    this.pageSize = event.pageSize;
    this.loadPage(this.currentPage, this.pageSize);
  }

  ngOnDestroy() {
    this.onDestroyNotifier$.next();
    this.onDestroyNotifier$.complete();
  }

  viewProperty(address) {
    this.propertyState.propertyDetailsSheetInput = address;
  }
  getAddressComponentsFromStandardAddress(address: any): any {
    if (!address) return null;

    return {
      StreetAddress: address.UnparsedAddress,
      City: address.City,
      State: address.StateOrProvince,
      PostalCode: address.PostalCode,
    };
  }

  private getExpiredListings(params: any) {
    this.isDataLoading = true;

    this.listingService
      .fetchExpiredListings(params)
      .pipe(takeUntil(this.onDestroyNotifier$))
      .subscribe(
        (res: any) => {
          this.isDataLoading = res.isLoading;
        },
        (err) => {
          console.error(err);
          this.isDataLoading = false;
        }
      );
  }
}
